function init() {
	const btnBack = document.querySelector('.js-back');

	if (btnBack) {
		btnBack.addEventListener('click', () => {
			const page = document.querySelector('body');
			const nav = document.querySelector('.service__side-block');

			if (page.classList.contains('page-service-connection-cms')) {
				history.back();
			} else {
				nav.classList.toggle('is-visible');
				document.querySelector('html').style.overflow = 'hidden';
			}
		});
	}
}

export default {
	init,
};
